(function () {
	'use strict';

	angular
	.module('core')
	.directive('topicReply', topicReply);

	topicReply.$inject = ['$sce', '$timeout'];

	function topicReply($sce, $timeout) {
		return {
			restrict: 'E',
			templateUrl: './templates/directives/topic-reply.html',
			scope:{
				'source':'=',
				'user':'=?',
				'level':'=?'
			},
			link: function($scope, elem) {
				if($scope.level == undefined){
					$scope.level = 0;
				}
			}
		}
	}
})();